import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { DateString, NonNegativeMonetaryValue } from '../fields';

export const CreateSubsidySettingRow = z.object({
  loanId: LosId,
  effectiveDate: DateString.describe('Statement date that subsidy takes effect'),
  amount: NonNegativeMonetaryValue.describe('Monthly subsidy amount. Cannot exceed the loan’s total payment (PITI)'),
});

export type CreateSubsidySettingRow = z.infer<typeof CreateSubsidySettingRow>;

export const CREATE_SUBSIDY_SETTING_ROW_REQUIRED_FIELDS = Object.keys(CreateSubsidySettingRow.shape).filter(
  (key) => !CreateSubsidySettingRow.shape[key as keyof typeof CreateSubsidySettingRow.shape].isOptional(),
) as (keyof CreateSubsidySettingRow)[];
